export default __webpack_public_path__ + "img/green-energy-sustainable.316d04b1.jpg";